import gql from 'graphql-tag';

const AllPromoCodes = gql`
  query AllPromoCodes($filter: PromoCodeFilter) {
    allPromoCodes(filter: $filter) {
      code
      id
      percentage
      active
      affiliate {
        id
        name
      }
    }
  }
`;

export { AllPromoCodes };



// WEBPACK FOOTER //
// ./src/queries/AllPromoCodes.js